import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import StarsComponent from "components/core/stars/stars-component";
import PersonalTextualInfo from "segments/desktop/core-components/person-textual-info/person-textual-info";
import { StyledReviewCard } from "./review-card.scss";
import DefaultProps from "./default-props";
import Colors from "styles/colors";
class ReviewCard extends PureComponent {
    render() {
        const { decorationColor, starsCount, name, jobDescription, title, showStars, fontSize, reviewCardOverrideHeight } = this.props;
        return /*#__PURE__*/ _jsxs(StyledReviewCard, {
            className: "review-card",
            style: {
                height: reviewCardOverrideHeight
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "review-card-color-decoration",
                    style: {
                        backgroundColor: Colors[decorationColor]
                    }
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "review-card-quote-title",
                    style: {
                        fontSize
                    },
                    dangerouslySetInnerHTML: {
                        __html: title
                    }
                }),
                showStars && /*#__PURE__*/ _jsx("div", {
                    className: "review-card-stars",
                    children: /*#__PURE__*/ _jsx(StarsComponent, {
                        starsCount: starsCount
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "review-card-quote-name",
                    children: /*#__PURE__*/ _jsx(PersonalTextualInfo, {
                        name: name,
                        jobDescription: jobDescription,
                        color: Colors["mud"],
                        className: "review-card-person-info"
                    })
                })
            ]
        });
    }
}
export { ReviewCard as default };
ReviewCard.defaultProps = DefaultProps;
